import { commentsItems, topicsItems, rankingItems } from '@/mocks/homeData';

export function CommentsSection() {
  return (
    <section id="comments" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="mb-8 md:mb-10 text-center">
          <h2 className="text-[24px] md:text-[30px] font-black text-foreground-950 font-heading mb-2">
            瓜友热评
          </h2>
          <p className="text-[14px] text-foreground-500">吃瓜群众的声音，真实又犀利</p>
        </div>
        <div className="space-y-4">
          {commentsItems.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-lg p-4 md:p-5 border border-background-200/70">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className="text-[14px] font-semibold text-foreground-900">{item.name}</span>
                    <span className="text-[12px] text-foreground-400">{item.date}</span>
                  </div>
                  <p className="text-[14px] text-foreground-700 leading-relaxed mb-2">
                    {item.content}
                  </p>
                  <div className="flex items-center gap-4">
                    <button className="flex items-center gap-1 text-[12px] text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer bg-transparent border-none">
                      <i className="ri-thumb-up-line"></i>
                      <span>{item.likes}</span>
                    </button>
                    <button className="flex items-center gap-1 text-[12px] text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer bg-transparent border-none">
                      <i className="ri-chat-1-line"></i>
                      <span>回复</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function TopicsSection() {
  return (
    <section id="topics" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-[24px] md:text-[30px] font-black text-foreground-950 font-heading mb-2">
            热门话题
          </h2>
          <p className="text-[14px] text-foreground-500">全网热议话题标签，看看大家都在聊什么</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {topicsItems.map((item) => (
            <a
              key={item.id}
              href="#topics"
              className="group flex flex-col items-center gap-2 p-4 md:p-5 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all no-underline"
            >
              <span className="text-[13px] md:text-[14px] font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors text-center">
                #{item.name}
              </span>
              <span className="text-[12px] text-accent-600 font-medium">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function RankingSection() {
  return (
    <section id="ranking" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-[24px] md:text-[30px] font-black text-foreground-950 font-heading mb-2">
            吃瓜热度榜
          </h2>
          <p className="text-[14px] text-foreground-500">实时热度排行，看看今天哪条瓜最火</p>
        </div>
        <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
          {rankingItems.map((item) => (
            <a
              key={item.id}
              href="#ranking"
              className="flex items-center gap-3 md:gap-4 px-4 md:px-5 py-3.5 border-b border-background-200/50 last:border-b-0 hover:bg-background-100/50 transition-colors no-underline group"
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-[14px] font-black flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>
              <span className="flex-1 text-[14px] font-medium text-foreground-800 group-hover:text-primary-700 transition-colors line-clamp-1">
                {item.title}
              </span>
              <span className="text-[13px] font-semibold text-accent-600 whitespace-nowrap flex-shrink-0">
                {item.heat}
              </span>
              <span
                className={`text-[12px] font-medium whitespace-nowrap flex-shrink-0 ${
                  item.trend === 'up'
                    ? 'text-primary-500'
                    : item.trend === 'down'
                      ? 'text-foreground-400'
                      : 'text-foreground-400'
                }`}
              >
                {item.change}
                {item.trend === 'up' && <i className="ri-arrow-up-s-line ml-0.5"></i>}
                {item.trend === 'down' && <i className="ri-arrow-down-s-line ml-0.5"></i>}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}